import {
  CHARGE_BEGIN,
  CHARGE_SUCCESS,
  CHARGE_FAILURE,
  APPLY_COUPON_STARTED,
  APPLY_COUPON_SUCCESS,
  SET_REMOVE_COUPON,
  FETCH_UPGRADE_PLAN_INVOICE_STARTED,
  FETCH_UPGRADE_PLAN_INVOICE_SUCCESS,
  FETCH_UPGRADE_PLAN_INVOICE_BEGIN,
  UPGRADE_PLAN_STARTED,
  UPGRADE_PLAN_SUCCESS
} from "../actionTypeConstants/constants";
import axios from "axios";
import { baseUrl } from "../../environments/environment";
import { toast } from "react-toastify";
import { getAccessToken } from "../../helpers/genericHelpers";
export const chargeBegin = () => {
  const action = {
    type: CHARGE_BEGIN,
  };
  return action;
};

export const chargeSuccess = (status) => {
  const action = {
    type: CHARGE_SUCCESS,
    payload: {
      status,
    },
  };
  return action;
};

export const chargeFailure = () => {
  const action = {
    type: CHARGE_FAILURE,
  };
  return action;
};

export const charge = (data) => {
  return (dispatch) => {
    dispatch(chargeBegin());
    axios
      .post(
        `${baseUrl}/user/${getAccessToken().id}/charge`,
        JSON.stringify(data),
        {
          headers: {
            "Content-type": "application/json",
            "API-Token": getAccessToken().api_token,
          },
        }
      )
      .then(function (response) {
        const res = response.data;
        if (res.status === "error") {
          toast.error(res.message);
        }
        if (res.status === "success") {
          dispatch(chargeSuccess(true));
          toast.success("Payment done successfully");
          dispatch(chargeSuccess(false));
        }
      })
      .catch(function (error) {
        dispatch(chargeFailure());
        const res = error.response.data || {};
        try {
          let parsedRes = JSON.parse(res.message);
          if(parsedRes && (parsedRes.code === "tax_id_invalid")) {
            toast.error("VAT number incorrect");
          } else {
            toast.error(parsedRes.message || res.message);
          }    
        } catch (e) {
          if (res.status === "error") {
            toast.error(res.message);
          }
        }
      });
  };
};



//APPLY COUPON 

export const setIsApplyCouponStarted = (status) => {
  const action = {
    type: APPLY_COUPON_STARTED,
    payload: {
      status,
    },
  };
  return action;
};

export const applyCouponSuccess = (data) => {
  const action = {
    type: APPLY_COUPON_SUCCESS,
    payload: { 
      data,
    }
  };
  return action;
};

export const applyCoupon = (data) => {
  return (dispatch) => {
    dispatch(setIsApplyCouponStarted(true));
    axios
      .post(
        `${baseUrl}/user/${getAccessToken().id}/verify-coupon`, JSON.stringify(data),
        {
          headers: {
            "Content-type": "application/json",
            "API-Token": getAccessToken().api_token,
          },
        }
      )
      .then(function (response) {
        const res = response.data;
        if (res.status === "error") {
          toast.error(res.message);
        }
        if (res.data.type === "success") {
          toast.success(res.data.message);
          let coupondata = {...res.data, coupon: data.coupon}
          dispatch(applyCouponSuccess(coupondata));
        }
        if (res.data.type === "error") {
          toast.error(res.data.message);
        }
        dispatch(setIsApplyCouponStarted(false));
      })
      .catch(function (error) {
        const res = error.response.data || {};
        if (res.status === "error") {
          toast.error(res.data.message);
        }
        dispatch(setIsApplyCouponStarted(false));
      });
  };
};

export const setRemoveCoupon = () => {
  const action = {
    type: SET_REMOVE_COUPON
  };
  return action;
};

export const removeCoupon = () => {
  return (dispatch) => {
    dispatch(setRemoveCoupon());
  };
};


// get invoice of upgrade plan


export const setIsFetchUpgradePlanInvoiceBegin = (status) => {
  const action = {
    type: FETCH_UPGRADE_PLAN_INVOICE_BEGIN,
    payload: {
      status,
    },
  };
  return action;
};

export const setIsFetchUpgradePlanInvoiceStarted = (status) => {
  const action = {
    type: FETCH_UPGRADE_PLAN_INVOICE_STARTED,
    payload: {
      status,
    },
  };
  return action;
};

export const fetchUpgradePlanInvoiceSuccess = (data) => {
  const action = {
    type: FETCH_UPGRADE_PLAN_INVOICE_SUCCESS,
    payload: { 
      data,
    }
  };
  return action;
};

export const fetchUpgradePlanInvoice = (data) => {
  return (dispatch) => {
    dispatch(setIsFetchUpgradePlanInvoiceStarted(true));
    dispatch(setIsFetchUpgradePlanInvoiceBegin(false));
    axios
      .post(
        `${baseUrl}/user/${getAccessToken().id}/invoices/upcoming`, JSON.stringify(data),
        {
          headers: {
            "Content-type": "application/json",
            "API-Token": getAccessToken().api_token,
          },
        }
      )
      .then(function (response) {
        const res = response.data;
        if (res.status === "error") {
          toast.error(res.message);
        }
        if (res.type === "success") {
          dispatch(fetchUpgradePlanInvoiceSuccess(res.data.uInvoive));
        }
        
        dispatch(setIsFetchUpgradePlanInvoiceStarted(false));
      })
      .catch(function (error) {
        const res = error.response.data || {};
        if (res.status === "error") {
          toast.error(res.data.message);
        }
        dispatch(setIsFetchUpgradePlanInvoiceStarted(false));
      });
  };
};


//upgrade plan


export const setIsUpgradePlanStarted = (status) => {
  const action = {
    type: UPGRADE_PLAN_STARTED,
    payload: {
      status,
    },
  };
  return action;
};

export const upgradePlanSuccess = (data) => {
  const action = {
    type: UPGRADE_PLAN_SUCCESS,
    payload: {
      data
    }
     
  };
  return action;
};


export const upgradePlan = (data) => {
  return (dispatch) => {
    dispatch(setIsUpgradePlanStarted(true));
    axios
      .post(
        `${baseUrl}/user/${getAccessToken().id}/subscription/upgrade-downgrade`, JSON.stringify(data),
        {
          headers: {
            "Content-type": "application/json",
            "API-Token": getAccessToken().api_token,
          },
        }
      )
      .then(function (response) {
        const res = response.data;
        if (res.status === "error") {
          toast.error(res.message);
        }
        if (res.type === "success") {
          dispatch(upgradePlanSuccess(true));
          toast.success("Plan has been updated successfully");
          dispatch(upgradePlanSuccess(false));
        }
        
        dispatch(setIsUpgradePlanStarted(false));
      })
      .catch(function (error) {
        const res = error.response.data || {};
        if (res.status === "error") {
          toast.error(res.data.message);
        }
        dispatch(setIsUpgradePlanStarted(false));
      });
  };
};
